function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
},
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3.52 19.038a3.436 3.436 0 01-2.462-1.007A3.315 3.315 0 010 15.5a4.352 4.352 0 011.441-2.834L11.675 2.432a4.877 4.877 0 116.9 6.895L9.65 18.251a.495.495 0 11-.7-.7l8.924-8.924a3.892 3.892 0 00-5.5-5.5L2.14 13.358a3.467 3.467 0 00-1.154 2.186 2.36 2.36 0 00.768 1.791 2.477 2.477 0 001.938.714 3.434 3.434 0 002.188-1.05l8.225-8.229a1.295 1.295 0 10-1.83-1.831l-6.844 6.843a.495.495 0 01-.7-.7l6.844-6.843a2.279 2.279 0 113.222 3.223l-8.225 8.23a4.416 4.416 0 01-2.824 1.336c-.074.008-.148.01-.228.01z"
}),
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
}));

var SvgAddAttachment = function SvgAddAttachment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAddAttachment, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/add_attachment.82b0bd17.svg";
export { ForwardRef as ReactComponent };